var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEmptyTracking = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 152,
  height: 164,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "url(#empty-tracking_svg__a)",
  fillRule: "evenodd",
  d: "M113.21 55.109c-.013-.356-1.56-35.725-17.014-48.461-4.58-3.774-9.99-5.208-16.08-4.266C67.299 4.365 58.435 13.794 53.77 30.406c-3.506 12.482-3.179 24.542-3.175 24.662l-1.179.037c-.003-.122-.337-12.34 3.21-24.992 2.093-7.46 5.105-13.618 8.956-18.304 4.84-5.893 11.016-9.457 18.354-10.593 6.436-.995 12.16.526 17.01 4.523 6.674 5.5 11.638 15.483 14.756 29.67 2.311 10.522 2.683 19.565 2.687 19.655z",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#empty-tracking_svg__b)",
  fillRule: "evenodd",
  d: "M1.02 153.375 16.687 50.112c.15-.987.99-1.72 1.987-1.737l90.519-1.496 19.58 116.576H8.727c-5.092 0-8.45-5.043-7.706-10.08",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#empty-tracking_svg__c)",
  fillRule: "evenodd",
  d: "m126.643 48.365-17.452-1.486 19.581 116.576 19.329-.499a3.058 3.058 0 0 0 2.914-3.684L127.996 49.474a1.54 1.54 0 0 0-1.353-1.11",
  clipRule: "evenodd"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#empty-tracking_svg__d)",
  fillRule: "evenodd",
  d: "M93.699 54.734c-.013-.356-1.56-35.726-17.015-48.461-4.58-3.773-9.99-5.209-16.08-4.266C47.789 3.99 38.925 13.419 34.259 30.03c-3.505 12.481-3.179 24.542-3.175 24.662l-1.179.037c-.003-.123-.337-12.34 3.212-24.992 2.092-7.46 5.104-13.618 8.954-18.304C46.911 5.541 53.086 1.977 60.425.841c6.436-.996 12.16.525 17.01 4.522 6.673 5.5 11.638 15.484 14.755 29.671 2.312 10.521 2.684 19.564 2.688 19.654z",
  clipRule: "evenodd"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M59.817 128.22c.87 1.998 2.834 3.402 5.126 3.402s4.256-1.404 5.126-3.402zM88.031 87.4l-2.567 1.45c2.484 3.674 3.799 7.622 3.799 12.164 0 4.504-1.522 8.679-3.816 12.174l2.596 1.425c2.534-3.868 4.239-8.528 4.239-13.599 0-5.034-1.504-9.553-4.251-13.615m-46.172 0c-2.75 4.06-4.255 8.58-4.255 13.614 0 5.071 1.706 9.731 4.245 13.599l2.59-1.425c-2.29-3.495-3.812-7.67-3.812-12.174 0-4.542 1.316-8.49 3.801-12.165zm52.673-3.403-2.25 1.421c2.682 4.494 4.2 9.858 4.2 15.588s-1.518 11.094-4.2 15.588l2.25 1.421c2.938-4.923 4.585-10.785 4.585-17.009 0-6.223-1.647-12.085-4.585-17.008m-59.178 0c-2.938 4.924-4.584 10.786-4.584 17.009s1.646 12.086 4.584 17.009l2.25-1.421c-2.682-4.494-4.2-9.858-4.2-15.588s1.518-11.094 4.2-15.588zm29.59-1.7c.947 0 1.708.74 1.708 1.661v1.74a21 21 0 0 0-1.709-.078c-.58 0-1.148.033-1.709.078v-1.74c0-.922.76-1.661 1.71-1.661m0-1.701c-2.25 0-4.101 1.816-4.101 4.02v1.826c-6.6 1.593-10.935 7.036-10.935 14.338v10.454c0 2.911-1.751 6.209-2.761 7.858l-2.477 3.643c-.278.408-.31.942-.07 1.377.24.434.706.707 1.207.707H84.08c.502 0 .966-.273 1.207-.707a1.32 1.32 0 0 0-.07-1.377l-2.44-3.59c-1.884-3.073-2.797-5.602-2.797-7.727v-10.454c0-7.39-4.336-12.904-10.935-14.51v-1.838c0-2.204-1.852-4.02-4.1-4.02",
  clipRule: "evenodd"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "empty-tracking_svg__a",
  x1: 81.253,
  x2: 67.102,
  y1: 56.977,
  y2: 169.594,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#08005D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#1A0E90"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "empty-tracking_svg__b",
  x1: 114.926,
  x2: 18.227,
  y1: 56.178,
  y2: 171.613,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#459DE8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#628DFD"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "empty-tracking_svg__c",
  x1: 268.469,
  x2: 130.067,
  y1: -3.994,
  y2: 104.189,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#4F9FFD"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#4C7CF8"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "empty-tracking_svg__d",
  x1: 61.998,
  x2: 47.848,
  y1: 54.557,
  y2: 167.175,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#08005D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#1A0E90"
})))));
export { SvgEmptyTracking as ReactComponent };
export default "data:image/svg+xml;base64,bW9kdWxlLmV4cG9ydHMgPSBfX3dlYnBhY2tfcHVibGljX3BhdGhfXyArICJzdGF0aWMvbWVkaWEvZW1wdHktdHJhY2tpbmcuZmQ3MzE5MjEuc3ZnIjs=";